import {SET_UNIT_REVIEWS} from './action-types';
import {TEMPLATE_ID_HEADER, BOT_HEADER} from '../utils/constants';

export function setReviews(payload) {
    return {
        type: SET_UNIT_REVIEWS,
        payload,
    };
}

export function fetchReviews({
    basePathPrefix,
    destinationName,
    lbsId,
    fullName,
    refinementKey = '',
}) {
    return (dispatch, getState) => {
        const {
            config: {
                template,
                context: {isBot},
            },
        } = getState();
        const query = {
            destinationName,
            lbsId,
            fullName,
        };

        if (refinementKey) {
            query.refinementKey = refinementKey;
        }

        const requestUrl = `${basePathPrefix}/api/unit-reviews?${new URLSearchParams(
            {...query}
        )}`;

        return fetch(requestUrl, {
            credentials: 'same-origin',
            headers: {
                [TEMPLATE_ID_HEADER]: template,
                [BOT_HEADER]: isBot,
            },
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed loading unit reviews');
                }

                return res.json();
            })
            .then((payload = {}) => {
                if (!Array.isArray(payload.items)) {
                    payload.items = [];
                }
                dispatch(setReviews(payload));
            })
            .catch((err) => console.log(err)); // eslint-disable-line no-console
    };
}
